import { useMemo, useState } from 'react';
import { AdminController } from '../../../../controllers';
import constant from '../../../../utils/constant';
import flutter_wave from '../../../../assets/img/flucter_wave.svg';
import instagram from '../../../../assets/img/instagram.svg';
import whatsapp from '../../../../assets/img/whatsapp.svg';
import facebook from '../../../../assets/img/facebook.svg';
import paystack from '../../../../assets/img/paystack.svg';
import snapchat from '../../../../assets/img/snapchat.svg';
import twitter from '../../../../assets/img/twitter.svg';
import jumia from '../../../../assets/img/jumia.svg';
import konga from '../../../../assets/img/konga.svg';
import jiji from '../../../../assets/img/jiji.svg';
import { BsFillPeopleFill } from 'react-icons/bs';
import styles from '../../../../assets/styles/Admin/AdminOrders.module.scss';
import moment from 'moment';
import { MimaOptionMenu } from '../../../../components';
import { adminStore } from '../../../../stores';
import { emptyOrderAnalysis } from '../../../../utils/admin';

export const useAdminOrdersLogic = () => {
	const { isLoading: isLoadingAnalysis, data } =
		AdminController.useGetOrdersAnalysis();

	const modalConstants = {
		view: 'VIEW-ORDER',
		update: 'UPDATE-ORDER',
	};

	const [openModal, setOpenModal] = useState('');

	const openModalHandler = (modalType, order) => {
		adminStore.setSelectedOrder(order);
		setOpenModal(modalType);
	};

	const closeModal = () => {
		adminStore.setSelectedOrder({});
		setOpenModal('');
	};

	const orderAnalysis = useMemo(() => {
		if (
			data?.status === constant.Success &&
			data?.data &&
			data?.data?.length > 0
		) {
			return data?.data?.map(item => ({
				label: `TOTAL ${item?.trackingStatus} ORDERS`,
				value: item?.total ?? 0,
			}));
		}

		return emptyOrderAnalysis;
	}, [data]);

	const {
		isLoading: isLoadingOrders,
		data: orderData,
		isFetching,
		onLimitChange,
		limit,
		currentPage,
		setCurrentPage,
		setSearchQuery,
	} = AdminController.useGetOrders(5);

	const tableData = useMemo(() => {
		if (orderData?.status === constant.Success) {
			return orderData?.data?.groups || [];
		}
		return [];
	}, [orderData]);

	const totalCounts = orderData?.data?.totalCounts ?? 0;

	const tableColumns = [
		{
			Header: 'Order ID',
			accessor: 'number',
			Cell: ({ cell }) => {
				const number = cell.row.original?.invoice?.number;
				return <span>{`ORD-${number}`}</span>;
			},
		},
		{
			Header: 'Order Date',
			accessor: 'createdAt',
			Cell: ({ cell }) => {
				const orderDate = cell.row.original.createdAt;
				const formattedDate = moment(orderDate).format('DD/MM/YYYY');
				return <span>{formattedDate}</span>;
			},
		},
		{
			Header: 'Customer Name',
			accessor: 'fullname',
			Cell: ({ cell }) => {
				const fullname = cell.row.original.invoice?.customer?.fullname;
				return <span>{fullname}</span>;
			},
		},
		{
			Header: 'Items',
			Cell: ({ cell }) => {
				const items = cell.row.original.invoice?.orders?.length;
				return <span>{items}</span>;
			},
		},
		{
			Header: 'Sales Channel',
			Cell: ({ cell }) => {
				const salesChannel = cell.row.original.invoice?.salesChannel;
				const imgStyle = { width: '3rem' };
				return (
					<span>
						{salesChannel === 'twitter' ? (
							<img src={twitter} alt="Twitter" style={imgStyle} />
						) : salesChannel === 'Instagram' ? (
							<img src={instagram} alt="Instagram" style={imgStyle} />
						) : salesChannel === 'WhatsApp' ? (
							<img src={whatsapp} alt="Whatsapp" style={imgStyle} />
						) : salesChannel === 'Facebook' ? (
							<img src={facebook} alt="Facebook" style={imgStyle} />
						) : salesChannel === 'Jiji' ? (
							<img src={jiji} alt="Jiji" style={imgStyle} />
						) : salesChannel === 'Jumia' ? (
							<img src={jumia} alt="Jumia" style={imgStyle} />
						) : salesChannel === 'Paystack' ? (
							<img src={paystack} alt="Paystack" style={imgStyle} />
						) : salesChannel === 'Flutterwave' ? (
							<img src={flutter_wave} alt="Flutterwave" style={imgStyle} />
						) : salesChannel === 'Konga' ? (
							<img src={konga} alt="Konga" style={imgStyle} />
						) : salesChannel === 'Snapchat' ? (
							<img src={snapchat} alt="Snapchat" style={imgStyle} />
						) : salesChannel === 'Physical sale' ? (
							<BsFillPeopleFill style={{ fontSize: '2.5rem' }} />
						) : (
							salesChannel
						)}
					</span>
				);
			},
		},
		{
			Header: 'Status',
			Cell: ({ cell }) => {
				const trackingStatus = cell.row.original.trackingStatus;
				return (
					<span
						className={
							trackingStatus === 'DELIVERED'
								? styles.delivered
								: trackingStatus === 'PROCESSING'
									? styles.processing
									: trackingStatus === 'REFUNDED'
										? styles.refunded
										: trackingStatus === 'SHIPPED'
											? styles.shipped
											: styles.void
						}>
						{trackingStatus}
					</span>
				);
			},
		},

		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const trackingStatus = cell.row.original.trackingStatus;
				const item = cell.row.original;
				return trackingStatus !== 'VOID' ? (
					<MimaOptionMenu
						options={[
							{
								value: 'View more',
								label: 'View more',
							},
							{
								value: 'Update Order status',
								label: 'Update Order status',
							},
						]}
						onOptionSelected={option => {
							if (option.value === 'View more') {
								openModalHandler(modalConstants.view, item);
							} else if (option.value === 'Update Order status') {
								openModalHandler(modalConstants.update, item);
							}
						}}
					/>
				) : null;
			},
		},
	];
	return {
		tableData,
		tableColumns,
		totalCounts,
		setSearchQuery,
		isFetching,
		onLimitChange,
		limit,
		currentPage,
		setCurrentPage,
		isLoadingAnalysis,
		orderAnalysis,
		isLoading: isLoadingAnalysis || isLoadingOrders,
		openModal,
		modalConstants,
		closeModal,
	};
};

export default useAdminOrdersLogic;
